import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AuthorizationService } from '@citi-gcg-173875/citi-security';

@Injectable()
export class MktSiteCatalystService {

  isBootstrapScriptLoaded;
  citiData: any;

  constructor(
    private authService: AuthorizationService,
    @Inject(PLATFORM_ID) private platformId: string) {
    if (isPlatformBrowser(this.platformId)) {
      this.authService.getSessionObservable().subscribe(isSessionActive => {
        window['citiData']['loginStatus'] = !!isSessionActive ? 'logged in' : 'not logged in';
        window['citiData']['custStatus'] = !!isSessionActive ? 'customer' : 'not known';
      });
    }
  }

  callSC(eventType, SCInfo) {
    if (!eventType || !SCInfo || !isPlatformBrowser(this.platformId)) {
      return;
    }

    if (!window['citiData']) {
      window['citiData'] = {};
    }

    const tempStorage = {
      ...window['citiData'],
      ...SCInfo,
      platform: this.getPlatform(),
      domain: window.location.hostname,
      year: new Date().getFullYear().toString(),
      defaultPageView: true
    };

    window['citiData'] = tempStorage;
    if (isPlatformBrowser(this.platformId)) console.log('Citi Data before event trigger', window['citiData']);

    !!window['Bootstrapper'] && window['Bootstrapper'].ensEvent.trigger(eventType);
  }

  getPlatform() {
    if (window.innerWidth > 983) {
      return 'desktop';
    } else if (window.innerWidth >= 600 && window.innerWidth <= 983) {
      return 'tablet';
    } else {
      return 'mobile';
    }
  }

  /* addBootstrapScript(): Promise<boolean> {
     return new Promise((resolve, error) => {
       let src = window['location']['hostname'] === 'www.citi.com' ? 'https://nexus.ensighten.com/citi/na_prod/Bootstrap.js' : 'https://nexus.ensighten.com/citi/na_stage/Bootstrap.js';
       let script = document.createElement("script");
       script.setAttribute("src", src);
       script.addEventListener('load', () => resolve(true));
       script.addEventListener('error', () => error(false));
       document.getElementsByTagName("head")[0].appendChild(script);
     });
   }  */
}
